export default __webpack_public_path__ + "static/media/26075_21.1f454c71.svg";